import {createTheme} from '@epic-ui/epic/src/index';

export const theme = createTheme();
